import React from 'react';


export default class TextUtil {
    // Primeira letra maiúscula, resto minúsculo
    static capitalizeFirst(text) {
        if (!text || typeof text !== 'string') return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    // Cada palavra com a primeira letra maiúscula
    static capitalizeWords(text) {
        if (!text || typeof text !== 'string') return '';
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
}
